import { handleActions } from 'redux-actions'

import {
  SET_COMPANY,
  LOGOUT,
} from '../../actions'

const initialState = {
  data: [],
}

export default handleActions({
  [SET_COMPANY]: (state, action) => ({
    ...state,
    data: action.payload,
  }),
  [LOGOUT]: () => initialState,
}, initialState)
